export const getHost = function() {
    if(process.env.NODE_ENV === 'development'){
        return 'http://127.0.0.1:3000';// 
    }

    return ''
}


export const url = {
    getConfig: 'get|/config',
    setConfig: 'post|/config',
}
